/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const IconWrapper = ({
  size = 24,
  color,
  icon,
  className,
  title,
  iconIndicator
}) => /*#__PURE__*/_jsx(Fragment, {
  children: /*#__PURE__*/_jsxs(StyledIcon, {
    className: className,
    size: size,
    color: color,
    title: title,
    children: [icon, iconIndicator && /*#__PURE__*/_jsx(Indicator, {})]
  })
});
const StyledIcon = styled(({
  className,
  children,
  title
}) => /*#__PURE__*/_jsx("div", {
  className: className,
  children: children,
  title: title
})).withConfig({
  displayName: "IconWrapper__StyledIcon",
  componentId: "sc-pweaxq-0"
})(["font-size:", "px;display:flex;align-items:center;color:", ";justify-content:center;"], props => props.size, props => props.color || 'inherit');
const Indicator = styled.span.withConfig({
  displayName: "IconWrapper__Indicator",
  componentId: "sc-pweaxq-1"
})(["height:12px;width:12px;background-color:", ";border-radius:50%;margin:0 -12px auto 0;"], Colors.RED_b10017);